module.exports = __webpack_public_path__ + "img/my_chaoshi.b7dde231.svg";